export default function HomeFooterCopyrightText() {
    // Used in HomeFooterBottomLinks to display Ummia
    // copyright text

    // PROPERTIES
    const year = new Date().getFullYear();

    // BUILD
    return (
        <p className={"text-backgroundLight5 font-normal text-[16px]"}>
            © {year} Ummia. Tous droits réservés.
        </p>
    )
}